// extracted by mini-css-extract-plugin
export default {"chat":"pQN5kAR7ticMI3ygQiyU","emptyAvatar":"bf5XZzSuAAudo1hnYJuH","lockIcon":"lpTS5eG7xHiSLceZZpWt","link":"iRKLnKYLI5gvHTQGt8Il","willReply":"c2O4VettR1MJdLPdx0BI"};